"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_STATE = void 0;
exports.INITIAL_STATE = {
    fetchUserError: null,
    fetchUserPending: false,
    fetchUserMeta: null,
};
